// extracted by mini-css-extract-plugin
export default {"message-placeholder":"tips_message-placeholder__d7744","button":"tips_button__7pywf"};